import { useCallback } from 'react'

import { noop } from 'lodash'

import api from 'common/api'

const HISTORICAL_SEARCH_URL = '/api/historical_search'

export const useOnClear = (setHistoricalResults: (results: any[]) => void) => {
  return useCallback(() => {
    return api
      .delete(HISTORICAL_SEARCH_URL)
      .then(() => setHistoricalResults([]))
      .catch(noop)
  }, [setHistoricalResults])
}
